import BaseComponent from "../../../../engines/components/BaseComponent";
import O1HD from "../../../../engines/gameEngine";
import utilsModel from "../../../../engines/libs/utilsModel";
import CsvDataManage from "../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../define/CsvFileKind";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../BundleResourceConfig";
import UserDataManage from "../../model/UserDataManage";
import MatchMiaiWeaponSelect from "./MatchMiaiWeaponSelect";


const {ccclass, property} = cc._decorator;

@ccclass
export default class MatchMiaiWeaponSelectItem extends BaseComponent {

    @property(cc.Node)
    sprSelect: cc.Node = null;
    @property(cc.Node)
    labelSelect: cc.Node = null;
    @property(cc.Node)
    nodeLock: cc.Node = null;
    @property(cc.Button)
    nodeBtn: cc.Button = null;

    @property(cc.Sprite)
    sprEquip: cc.Sprite = null;

    @property(cc.Label)
    labelName: cc.Label = null;

    private equipId: string = null;

    private _parent: MatchMiaiWeaponSelect = null;

    private csvInfos: any = null;
    
    start(){
       this.initUI();
    }

    setData(
        equipId: string
        , _parent: MatchMiaiWeaponSelect
    ) {
        this.equipId = equipId;
        this._parent = _parent;
    }

    initUI(){
        let id = this.equipId;
        let csvInfos = this.csvInfos = CsvDataManage.instance.getCsvDataItem(
            CsvFileKind.CsvFile.MATCH_MIAI
            , id
        );
        if (!csvInfos) {
            console.error(`未找到武器数据 id = `, id);
            return;
        }

        let matchMiaiDataManage = UserDataManage.instance.matchMiaiDataManage;
        let matchMiaiData = matchMiaiDataManage.matchMiaiData;
        let bOwn = matchMiaiData.ownEquipList.includes(id);
        
        let sprSelect = this.sprSelect;
        let labelSelect = this.labelSelect;
        let nodeLock = this.nodeLock;

        let sprBg = this.sprEquip;
        sprBg.node.active = false;
        let equipPath = 'res/equip/' + csvInfos.icon;
        let gwidth = sprBg.node.width;
        let gheight = sprBg.node.height;
        getOneBundleByInstant(BUNDLE_SMALL_NAME.matchMiaiBundle).load(equipPath,cc.SpriteFrame,(err,spr:cc.SpriteFrame)=>{
            if(err){
                console.error(err,"showEuqipUI");
                return;
            }
            sprBg.node.active = true;
            sprBg.spriteFrame = spr;

            let scale = Math.min(gwidth / sprBg.node.width, gheight / sprBg.node.height);
            sprBg.node.scale = scale;    
        });

        sprSelect.active = false;
        labelSelect.active = false;
        nodeLock.active = false;
        if (!bOwn) {
            nodeLock.active = true;
        } else {
            if (matchMiaiData.curUseEquip == id) {
                sprSelect.active = true;
                labelSelect.active = true;
            } else {
                
            }
        }

        let label = this.labelName;
        label.string = csvInfos.name;
    }

    onBtnClick(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
    }

    onClickSwitchEquip(event: cc.Event.EventTouch) {
        O1HD.getManagers().soundMgr.playSound("anNiu");

        let id = this.equipId;
        let matchMiaiDataManage = UserDataManage.instance.matchMiaiDataManage;
        let matchMiaiData = matchMiaiDataManage.matchMiaiData;

        if (matchMiaiData.curUseEquip == id) {
            this._parent.resumeHit();
            console.log(`正在使用`);
            return;
        } 

        if (!matchMiaiData.ownEquipList.includes(id)) {
            if (utilsModel.isValidNumberValue(this.csvInfos.special_type)) {
                O1HD.getModules().uiControlModule.showMessageBox('未获得此装备');
                return;
            }
            // 没有此装备，打开装备购买界面
            this._parent.openBuyEquipLayer();

        } else {
            // 已拥有，切换装备
            matchMiaiData.curUseEquip = id;
            matchMiaiData.saveLocalData();
            this._parent.showEuqipUI();
        }
        this._parent.resumeHit();
    }
}
